import { render, staticRenderFns } from "./InputDropdown.vue?vue&type=template&id=482e5c4e"
import script from "./InputDropdown.vue?vue&type=script&lang=js"
export * from "./InputDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports